import {
    AirtableSVGIcon,
    AsanaSVGIcon,
    AttioSVGIcon,
    BoxSVGIcon,
    ClickUpSVGICON,
    CloseCRMSVGIcon,
    // CodaSVGIcon,
    ConfluenceSVGIcon,
    // DocuSignSVGIcon,
    DropboxSVGIcon,
    GoogleDriveSVGIcon,
    GoogleSheetsSVGIcon,
    HubSpotSVGIcon,
    // MiroSVGIcon,
    MondayDotComSVGIcon,
    NotionSVGIcon,
    PipedriveSVGIcon,
    SlackSVGIcon,
    SmartsheetSVGIcon,
    // WealthboxSVGIcon,
    WrikeSVGIcon,
} from '@/assets';

import { isCommandPaletteSearchableProviderGroup } from '../00-CommandPaletteTabs/preferences';

export const COMMAND_PALETTE_DATA_SOURCE_GROUPS = {
    airtable: { label: 'Airtable', icon: AirtableSVGIcon },
    asana: { label: 'Asana', icon: AsanaSVGIcon },
    attio: { label: 'Attio', icon: AttioSVGIcon },
    box: { label: 'Box', icon: BoxSVGIcon },
    clickup: { label: 'ClickUp', icon: ClickUpSVGICON },
    close: { label: 'Close', icon: CloseCRMSVGIcon },
    // coda: { label: 'Coda', icon: CodaSVGIcon },
    confluence: { label: 'Confluence', icon: ConfluenceSVGIcon },
    // docusign: { label: 'DocuSign', icon: DocuSignSVGIcon },
    dropbox: { label: 'Dropbox', icon: DropboxSVGIcon },
    googleDrive: { label: 'Google Drive', icon: GoogleDriveSVGIcon },
    googleSheets: { label: 'Google Sheets', icon: GoogleSheetsSVGIcon },
    hubspot: { label: 'HubSpot', icon: HubSpotSVGIcon },
    // miro: { label: 'Miro', icon: MiroSVGIcon },
    monday: { label: 'Monday.com', icon: MondayDotComSVGIcon },
    notion: { label: 'Notion', icon: NotionSVGIcon },
    pipedrive: { label: 'Pipedrive', icon: PipedriveSVGIcon },
    slack: { label: 'Slack', icon: SlackSVGIcon },
    smartsheet: { label: 'Smartsheet', icon: SmartsheetSVGIcon },
    // wealthbox: { label: 'Wealthbox', icon: WealthboxSVGIcon },
    wrike: { label: 'Wrike', icon: WrikeSVGIcon },
} as const;

export const commandPaletteDataSourceGroupOrder = Object.keys(COMMAND_PALETTE_DATA_SOURCE_GROUPS);

const commandPaletteDataSourceGroupKeys = new Set(commandPaletteDataSourceGroupOrder);

export const isCommandPaletteDataSourceGroup = (group: string) =>
    isCommandPaletteSearchableProviderGroup(group) && commandPaletteDataSourceGroupKeys.has(group);
